import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=777e6897&"
import script from "./DownloadBtn.vue?vue&type=script&lang=js&"
export * from "./DownloadBtn.vue?vue&type=script&lang=js&"
import style0 from "./DownloadBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports